import React, { useState } from 'react';
import { SkeletonLoader } from 'app/components/common/skeleton-loader/skeleton-loader';
import { BodyText, FlexColumn, PageTile, SvgIcon } from '@make-software/cspr-design';
import styled from 'styled-components';
import { AppDescriptiveData } from 'app/components/management/apps/settings/view/app-descriptive-data';
import { AppIntegrationData } from 'app/components/management/apps/settings/view/app-integration-data';
import { ErrorResult } from 'app/organizations-api/types';
import { ErrorWindow } from 'app/components/common/error-window/error-window';
import NotFoundIcon from 'assets/logos/no-found.svg';
import { useTabsCtx } from 'app/components/management/apps/tabs-page-layout';
import { PageContainer, ViewPageContainer } from 'app/components/common/common-styles';

const Container = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    margin: ['0', '10', '0px 48px 48px 48px']
  })
);

export const StyledContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    '& > * + *': {
      marginTop: [28]
    }
  })
);

const LoadingContainer = styled(StyledContainer)(() => ({
  marginTop: '20px'
}));

export const AppViewPage = () => {
  const { app } = useTabsCtx();

  const [unexpectedError, setUnexpectedError] = useState<ErrorResult | null>(null);

  if (!app) {
    return (
      <Container>
        <h1>View App</h1>
        <PageTile>
          <Container justify={'center'} align={'center'}>
            <LoadingContainer>
              <SkeletonLoader height={'300px'} />
              <SkeletonLoader height={'300px'} />
              <SkeletonLoader height={'300px'} />
            </LoadingContainer>
          </Container>
        </PageTile>
      </Container>
    );
  }

  if (unexpectedError) {
    return (
      <ErrorWindow
        withModal
        title={unexpectedError.code}
        information={unexpectedError.message}
        icon={<SvgIcon src={NotFoundIcon} width={219} height={125} />}
      />
    );
  }

  return (
    <FlexColumn style={{ width: '100%' }} gap={32}>
      <PageContainer>
        <ViewPageContainer>
          <AppDescriptiveData app={app} />
        </ViewPageContainer>
      </PageContainer>
      <PageContainer>
        <ViewPageContainer>
          <AppIntegrationData app={app} />
        </ViewPageContainer>
      </PageContainer>
    </FlexColumn>
  );
};
